module.exports = __webpack_public_path__ + "static/media/module3.c29ad916.jpg";